class TaskMessageTemplateCategoryPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_message_template_category.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_message_template_category._m';

    // Can access archived categories
    static ACCESS_ARCHIVE = 'task_message_template_category.access.archive';

    // Can create category
    static CREATE = 'task_message_template_category.create';

    // Can update category
    static UPDATE = 'task_message_template_category.update';

    // Can archive category
    static ARCHIVE = 'task_message_template_category.archive';

    // Can restore archived category
    static RESTORE = 'task_message_template_category.restore';
}

export default TaskMessageTemplateCategoryPermission;
